import React, { useEffect, useState } from 'react';
import styles from './licensing.module.scss';
import { Typography } from '../Typography';
import { Button } from '../Button';
import { useLicensingSettings, LicensingSettings } from '../../utils/licensingService';
import { useRouter } from 'next/router';
import Modal from '../common/Modal';
import Subscriptions from './Subscriptions';
import { Fade } from 'react-awesome-reveal';
import toast from 'react-hot-toast';
import { subscriptionService } from '../../utils/subscriptionService';
import BinaryModal from './BinaryModal';
import axios from 'axios';
import { getProductIdBySlug } from '../../data/products';

type FetchState =
  | { status: 'idle' | 'loading' }
  | { status: 'error'; message: string }
  | { status: 'success'; data: LicensingSettings };

const CircleBoltIcon: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#7F56D9"
    />
    <path
      d="M24.9989 14L16.0923 24.6879C15.7435 25.1064 15.5691 25.3157 15.5665 25.4925C15.5641 25.6461 15.6326 25.7923 15.7521 25.8889C15.8896 26 16.1621 26 16.7069 26H23.9989L22.9989 34L31.9054 23.3121C32.2542 22.8936 32.4286 22.6843 32.4313 22.5075C32.4336 22.3539 32.3652 22.2077 32.2456 22.1111C32.1081 22 31.8357 22 31.2909 22H23.9989L24.9989 14Z"
      stroke="#E9D7FE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LayersIcon: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#7F56D9"
    />
    <path
      d="M14 26.4999L23.6422 31.3211C23.7734 31.3866 23.839 31.4194 23.9078 31.4324C23.9687 31.4438 24.0313 31.4438 24.0922 31.4324C24.161 31.4194 24.2266 31.3866 24.3578 31.3211L34 26.4999M14 21.4999L23.6422 16.6788C23.7734 16.6132 23.839 16.5804 23.9078 16.5675C23.9687 16.5561 24.0313 16.5561 24.0922 16.5675C24.161 16.5804 24.2266 16.6132 24.3578 16.6788L34 21.4999L24.3578 26.3211C24.2266 26.3866 24.161 26.4194 24.0922 26.4324C24.0313 26.4438 23.9687 26.4438 23.9078 26.4324C23.839 26.4194 23.7734 26.3866 23.6422 26.3211L14 21.4999Z"
      stroke="#E9D7FE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ListLayersIcon: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#7F56D9"
    />
    <path
      d="M14 23.9999L23.6422 28.8211C23.7734 28.8866 23.839 28.9194 23.9078 28.9324C23.9687 28.9438 24.0313 28.9438 24.0922 28.9324C24.161 28.9194 24.2266 28.8866 24.3578 28.8211L34 23.9999M14 28.9999L23.6422 33.8211C23.7734 33.8866 23.839 33.9194 23.9078 33.9324C23.9687 33.9438 24.0313 33.9438 24.0922 33.9324C24.161 33.9194 24.2266 33.8866 24.3578 33.8211L34 28.9999M14 18.9999L23.6422 14.1788C23.7734 14.1132 23.839 14.0804 23.9078 14.0675C23.9687 14.0561 24.0313 14.0561 24.0922 14.0675C24.161 14.0804 24.2266 14.1132 24.3578 14.1788L34 18.9999L24.3578 23.8211C24.2266 23.8866 24.161 23.9194 24.0922 23.9324C24.0313 23.9438 23.9687 23.9438 23.9078 23.9324C23.839 23.9194 23.7734 23.8866 23.6422 23.8211L14 18.9999Z"
      stroke="#E9D7FE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
      fill="#9E77ED"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.098 7.39004L9.93797 14.3L8.03797 12.27C7.68797 11.94 7.13797 11.92 6.73797 12.2C6.34797 12.49 6.23797 13 6.47797 13.41L8.72797 17.07C8.94797 17.41 9.32797 17.62 9.75797 17.62C10.168 17.62 10.558 17.41 10.778 17.07C11.138 16.6 18.008 8.41004 18.008 8.41004C18.908 7.49004 17.818 6.68004 17.098 7.38004V7.39004Z"
      fill="#E9D7FE"
    />
  </svg>
);

type PromotionStep = {
  discountPercentage: number;
  maxOrders: number;
  usedOrders?: number;
};

type PromotionData = {
  _id: string;
  name: string;
  description: string;
  preorderPrice: {
    usd: number;
    eur: number;
  };
  isActive: boolean;
  steps?: PromotionStep[];
};

type Package = {
  _id: string;
  name: string;
  subtitle?: string;
  product: {
    _id: string;
    product_name: string;
  };
  hostLimit: number;
  hardwareLimit: number;
  price: {
    usd: number;
    eur: number;
  };
  freeUpdateDuration?: number;
  services?: string[];
  hidden: boolean;
};

const Card: React.FC<{
  title: string;
  points: string[];
  actionText: string;
  onClick?: () => void;
  Icon?: React.ComponentType<{ size?: number }>;
  promotion?: PromotionData | null;
  currency?: 'usd' | 'eur';
  loading?: boolean;
}> = ({
  title,
  points,
  actionText,
  onClick,
  Icon = CircleBoltIcon,
  promotion,
  currency = 'eur',
  loading = false,
}) => {
  const displayTitle = promotion ? promotion.name : title;
  const displayPrice = promotion
    ? currency === 'eur'
      ? `€${promotion.preorderPrice[currency].toLocaleString()} / year`
      : `€${promotion.preorderPrice[currency].toLocaleString()} / year`
    : null;

  // If promotion exists, combine description and price in points array
  const displayPoints = promotion
    ? displayPrice
      ? [promotion.description, displayPrice]
      : [promotion.description]
    : points;

  return (
    <div className={styles.planCard}>
      <div className={styles.planHeader} style={{ alignItems: 'center', textAlign: 'center' }}>
        <div style={{ marginBottom: 8, display: 'inline-flex' }}>
          <Icon size={48} />
        </div>
        <Typography variant="display-sm" color="grayDark-50" weight="semibold">
          {displayTitle}
        </Typography>
      </div>
      <ul
        className={styles.planFeatures}
        style={{ listStyle: 'none', padding: 0, margin: 0, borderTop: 'none' }}
      >
        {displayPoints.map((p, idx) => (
          <li
            key={idx}
            style={{ display: 'flex', alignItems: promotion ? 'flex-start' : 'center', gap: 12 }}
          >
            <span style={{ display: 'inline-flex', flexShrink: 0 }}>
              <CheckIcon size={20} />
            </span>
            <Typography variant="text-md" color="grayDark-300" style={{ flex: 1 }}>
              {p}
            </Typography>
          </li>
        ))}
      </ul>
      <div
        className={styles.planCta}
        style={{
          borderTop: '1px solid var(--color-gray-dark-700)',
          marginTop: 24,
          // Figma-like bottom strip background
          marginLeft: -32,
          marginRight: -32,
          marginBottom: -32,
          padding: '24px 32px',
          background: 'rgba(255, 255, 255, 0.03)',
          borderBottomLeftRadius: 16,
          borderBottomRightRadius: 16,
        }}
      >
        <div style={{ width: '100%' }}>
          <Button
            variant="primary"
            onClick={onClick}
            fullWidth
            disabled={loading}
            loading={loading}
          >
            {actionText}
          </Button>
        </div>
      </div>
    </div>
  );
};

const LicensingSkeleton: React.FC = () => {
  return (
    <>
      {/* Tabs Skeleton */}
      <div className={styles.tabs} style={{ opacity: 0.4 }}>
        <div className={`${styles.tabButton} ${styles.skeletonTab}`} />
        <div className={`${styles.tabButton} ${styles.skeletonTab}`} />
      </div>
      {/* Table Skeleton */}
      <div className={styles.packagesTableWrapper}>
        <div className={styles.tableSkeleton}>
          {/* Header row */}
          <div className={styles.skeletonRow} style={{ height: '60px', marginBottom: '12px' }} />
          {/* Data rows */}
          <div className={styles.skeletonRow} style={{ height: '48px', marginBottom: '12px' }} />
          <div className={styles.skeletonRow} style={{ height: '48px', marginBottom: '12px' }} />
          <div className={styles.skeletonRow} style={{ height: '48px', marginBottom: '12px' }} />
          <div className={styles.skeletonRow} style={{ height: '48px', marginBottom: '12px' }} />
          <div className={styles.skeletonRow} style={{ height: '64px' }} />
        </div>
      </div>
    </>
  );
};

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || process.env.NEXT_PUBLIC_REACT_APP_BASE_URL1 || '';

const LicensingOptions: React.FC = () => {
  const licensingQuery = useLicensingSettings();
  const state: FetchState = licensingQuery.isLoading
    ? { status: 'loading' }
    : licensingQuery.isError
      ? {
          status: 'error',
          message:
            (licensingQuery.error as any)?.response?.data?.message ||
            (licensingQuery.error as any)?.message ||
            'Failed to load licensing settings.',
        }
      : licensingQuery.data
        ? { status: 'success', data: licensingQuery.data }
        : { status: 'idle' };
  const router = useRouter();
  // Get productId from slug in URL
  const slug = (router.query.url as string) || '';
  const productId = slug ? getProductIdBySlug(slug) || '' : '';
  const [binaryOpen, setBinaryOpen] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalWidth, setModalWidth] = useState<number>(1040);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [promotion, setPromotion] = useState<PromotionData | null>(null);
  const [promotionLoading, setPromotionLoading] = useState(false);
  const [currency, setCurrency] = useState<'usd' | 'eur'>('eur');
  const [subscriptionCurrency, setSubscriptionCurrency] = useState<'usd' | 'eur'>('eur');
  const [packages, setPackages] = useState<Package[]>([]);
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState<Package | null>(null);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<'binary' | 'subscription'>('binary');

  // Fetch promotion for product
  useEffect(() => {
    if (!productId) return;

    let mounted = true;
    const fetchPromotion = async () => {
      try {
        setPromotionLoading(true);
        const response = await axios.get(`${API_BASE_URL}/promotions/product/${productId}/active`);
        if (!mounted) return;

        // Handle different response formats: { data: {...} } or direct {...} or null
        const promotionData =
          response.data?.data !== undefined ? response.data.data : response.data;

        // If response is null or empty, no active promotion
        if (!promotionData) {
          setPromotion(null);
        } else if (promotionData.isActive) {
          setPromotion(promotionData);
        } else {
          setPromotion(null);
        }
      } catch (e: any) {
        if (!mounted) return;
        // If 404 or no active promotion, set to null (not an error)
        if (e?.response?.status === 404 || e?.response?.status === 400) {
          setPromotion(null);
        } else {
          console.error('Error fetching promotion:', e);
          setPromotion(null);
        }
      } finally {
        if (mounted) {
          setPromotionLoading(false);
        }
      }
    };

    fetchPromotion();
    return () => {
      mounted = false;
    };
  }, [productId]);

  // Detect user currency preference (can be enhanced later)
  useEffect(() => {
    // Simple detection - can be enhanced with user preference or geolocation
    const userLang = typeof window !== 'undefined' ? navigator.language : 'en-US';
    if (
      userLang.toLowerCase().includes('eu') ||
      userLang.toLowerCase().includes('de') ||
      userLang.toLowerCase().includes('fr')
    ) {
      setCurrency('eur');
    } else {
      setCurrency('eur');
    }
  }, []);

  // Fetch packages for product
  useEffect(() => {
    if (!productId) return;

    let mounted = true;
    const fetchPackages = async () => {
      try {
        setPackagesLoading(true);
        const response = await axios.get(`${API_BASE_URL}/packages?productId=${productId}`);
        if (!mounted) return;

        if (response.data?.success && response.data?.data) {
          // Filter out hidden packages for non-admin users
          const token = localStorage.getItem('auth-token');
          const allPackages = response.data.data as Package[];
          // For now, show all packages. Admin check can be added later if needed
          const visiblePackages = allPackages.filter((pkg) => !pkg.hidden);
          // Reverse the array to match the correct order
          setPackages(visiblePackages.reverse());
        }
      } catch (e: any) {
        if (!mounted) return;
        console.error('Error fetching packages:', e);
        setPackages([]);
      } finally {
        if (mounted) {
          setPackagesLoading(false);
        }
      }
    };

    fetchPackages();
    return () => {
      mounted = false;
    };
  }, [productId]);

  useEffect(() => {
    let mounted = true;
    const onResize = () => {
      if (!mounted) return;
      setIsMobile(typeof window !== 'undefined' && window.innerWidth <= 480);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      mounted = false;
      window.removeEventListener('resize', onResize);
    };
  }, []);

  // Set initial active tab based on available options
  const showSubscriptionOption = state.status === 'success' && state.data.showSubscription;
  const showBinaryOption = state.status === 'success' && state.data.showBinary;

  useEffect(() => {
    if (state.status === 'success') {
      const { data } = state;
      const showTabs = data.showSubscription && data.showBinary;
      if (showTabs) {
        // If both are available, default to binary
        setActiveTab('binary');
      } else if (data.showSubscription) {
        setActiveTab('subscription');
      } else if (data.showBinary) {
        setActiveTab('binary');
      }
    }
    // `state` is rebuilt as a new object every render (derived inline from
    // licensingQuery), so depending on it directly re-ran this effect - and
    // reset activeTab back to its default - on every click that changed
    // activeTab. Depend on the primitive values that should actually drive
    // the default tab instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.status, showSubscriptionOption, showBinaryOption]);

  if (state.status === 'loading' || state.status === 'idle') {
    return (
      <div className={styles.licensingContainer}>
        <div className={styles.licensingContent}>
          <div className={styles.licensingHeader}>
            <Typography variant="text-md" color="grayDark-300">
              Overview
            </Typography>
            <Typography
              variant="display-md"
              color="grayDark-50"
              weight="semibold"
              className={styles.licensingTitle}
            >
              Licensing Options
            </Typography>
          </div>
          <LicensingSkeleton />
        </div>
      </div>
    );
  }

  if (state.status === 'error') {
    // Fail-safe: render nothing (per requirement), optional small message aside
    return (
      <div className={styles.licensingContainer}>
        <div className={styles.licensingContent}>
          <div className={styles.licensingHeader}>
            <Typography variant="text-md" color="grayDark-400">
              Failed to load licensing settings.
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  if (state.status !== 'success') {
    return null;
  }
  const { data } = state;

  // Determine if we should show tabs (both are true)
  const showTabs = data.showSubscription && data.showBinary;

  // Find the highest step that still has available slots
  const getActiveStep = (promotion: PromotionData | null): PromotionStep | null => {
    if (!promotion || !promotion.steps || promotion.steps.length === 0) {
      return null;
    }

    // Sort steps by discountPercentage descending to find the highest available step
    const sortedSteps = [...promotion.steps].sort(
      (a, b) => b.discountPercentage - a.discountPercentage
    );

    // Find the first step that still has available slots
    for (const step of sortedSteps) {
      const usedOrders = step.usedOrders || 0;
      if (usedOrders < step.maxOrders) {
        return step;
      }
    }

    return null;
  };

  const activeStep = getActiveStep(promotion);

  return (
    <div className={styles.licensingContainer} id="licensing-options">
      <div className={styles.licensingContent}>
        <div className={styles.licensingHeader}>
          <Typography variant="text-md" color="grayDark-300">
            Overview
          </Typography>
          <Typography
            variant="display-md"
            color="grayDark-50"
            weight="semibold"
            className={styles.licensingTitle}
          >
            Licensing Options
          </Typography>
          <Typography variant="text-xl" color="grayDark-400">
            Select the license model that fits your usage and access level
          </Typography>
        </div>
        {/* Tabs - only show when both options are available */}
        {showTabs && (
          <div className={styles.tabs}>
            <Typography
              variant="text-sm"
              as="p"
              color="secondary"
              weight="normal"
              className={`${styles.tabButton} ${activeTab === 'binary' ? styles.active : ''}`}
              onClick={() => setActiveTab('binary')}
            >
              Binary
            </Typography>
            <Typography
              variant="text-sm"
              as="p"
              color="secondary"
              weight="normal"
              className={`${styles.tabButton} ${activeTab === 'subscription' ? styles.active : ''}`}
              onClick={() => setActiveTab('subscription')}
            >
              Subscriptions
            </Typography>
          </div>
        )}
        {/* Subscription content - show when tabs are not shown and subscription is available, or when tabs are shown and subscription tab is active */}
        {data.showSubscription && (!showTabs || activeTab === 'subscription') && (
          <Subscriptions
            currency={subscriptionCurrency}
            onCurrencyChange={setSubscriptionCurrency}
          />
        )}
        {/* Binary content - show when tabs are not shown and binary is available, or when tabs are shown and binary tab is active */}
        {data.showBinary && (!showTabs || activeTab === 'binary') && packages.length > 0 && (
          <>
            {/* Desktop Table View */}
            <div className={styles.packagesTableWrapper}>
              <table
                className={styles.packagesTable}
                data-hovered-column={hoveredColumn}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                <thead>
                  <tr>
                    <th data-column="0"></th>
                    {packages.map((pkg, index) => (
                      <th
                        key={pkg._id}
                        data-column={`${index + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <Typography variant="text-md" color="grayDark-50" weight="semibold">
                            {pkg.name}
                          </Typography>
                          {pkg.subtitle && (
                            <Typography variant="text-sm" color="grayDark-400">
                              {pkg.subtitle}
                            </Typography>
                          )}
                        </div>
                      </th>
                    ))}
                    {data.showSourceCode && (
                      <th
                        data-column={`${packages.length + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                      >
                        <Typography variant="text-md" color="grayDark-50" weight="semibold">
                          Source Code
                        </Typography>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr className={styles.highlightedRow}>
                    <td data-column="0">
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Supported hosts
                      </Typography>
                    </td>
                    {packages.map((pkg, index) => (
                      <td
                        key={pkg._id}
                        data-column={`${index + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                      >
                        <Typography variant="text-sm" color="grayDark-400">
                          {pkg.hostLimit.toLocaleString()}
                        </Typography>
                      </td>
                    ))}
                    {data.showSourceCode && (
                      <td
                        data-column={`${packages.length + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                      >
                        <Typography variant="text-sm" color="grayDark-400">
                          —
                        </Typography>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td data-column="0">
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Development machines
                      </Typography>
                    </td>
                    {packages.map((pkg, index) => {
                      const isLastPackage = index === packages.length - 1;
                      const displayValue = isLastPackage
                        ? `${pkg.hardwareLimit.toLocaleString()}+`
                        : pkg.hardwareLimit.toLocaleString();
                      return (
                        <td
                          key={pkg._id}
                          data-column={`${index + 1}`}
                          onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                        >
                          <Typography variant="text-sm" color="grayDark-400">
                            {displayValue}
                          </Typography>
                        </td>
                      );
                    })}
                    {data.showSourceCode && (
                      <td
                        data-column={`${packages.length + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                      >
                        <Typography variant="text-sm" color="grayDark-400">
                          —
                        </Typography>
                      </td>
                    )}
                  </tr>
                  <tr className={styles.highlightedRow}>
                    <td data-column="0">
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Normal price
                      </Typography>
                    </td>
                    {packages.map((pkg, index) => {
                      const hasPromotion = promotion && promotion.isActive;
                      return (
                        <td
                          key={pkg._id}
                          data-column={`${index + 1}`}
                          onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                        >
                          <Typography
                            variant="text-sm"
                            color={hasPromotion ? 'grayDark-300' : 'grayDark-50'}
                            weight={hasPromotion ? undefined : 'semibold'}
                            style={
                              hasPromotion
                                ? {
                                    textDecoration: 'line-through',
                                    opacity: 0.6,
                                  }
                                : {}
                            }
                          >
                            {currency === 'eur'
                              ? `€${pkg.price.eur.toLocaleString()}`
                              : `€${pkg.price.eur.toLocaleString()}`}
                          </Typography>
                        </td>
                      );
                    })}
                    {data.showSourceCode && (
                      <td
                        data-column={`${packages.length + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                      >
                        <Typography variant="text-sm" color="grayDark-400">
                          —
                        </Typography>
                      </td>
                    )}
                  </tr>
                  {/* Pre order row - only show if promotion exists */}
                  {promotion && promotion.isActive && (
                    <tr>
                      <td data-column="0">
                        <div className={styles.preorderLabelContainer}>
                          <Typography variant="text-sm" color="grayDark-300" weight="medium">
                            {promotion.name}
                          </Typography>
                          {activeStep && (
                            <Typography
                              variant="text-xs"
                              className={styles.preorderDescriptionLabel}
                            >
                              {activeStep.discountPercentage}% {promotion.description}
                            </Typography>
                          )}
                        </div>
                      </td>
                      {packages.map((pkg, index) => {
                        // Calculate final price with discount from active step
                        const packagePrice = currency === 'eur' ? pkg.price.eur : pkg.price.usd;
                        const finalPrice = activeStep
                          ? packagePrice * (1 - activeStep.discountPercentage / 100)
                          : packagePrice;

                        return (
                          <td
                            key={pkg._id}
                            data-column={`${index + 1}`}
                            onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                          >
                            <Typography variant="text-sm" className={styles.preorderPrice}>
                              {currency === 'eur'
                                ? `€${Math.round(finalPrice).toLocaleString()}`
                                : `€${Math.round(finalPrice).toLocaleString()}`}
                            </Typography>
                          </td>
                        );
                      })}
                      {data.showSourceCode && (
                        <td
                          data-column={`${packages.length + 1}`}
                          onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                        >
                          <Typography variant="text-sm" color="grayDark-400">
                            —
                          </Typography>
                        </td>
                      )}
                    </tr>
                  )}
                  {(packages.some((pkg) => pkg.freeUpdateDuration !== undefined) ||
                    packages.some((pkg) => pkg.services && pkg.services.length > 0)) && (
                    <tr className={styles.highlightedRow}>
                      <td data-column="0" style={{ verticalAlign: 'top' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <Typography variant="text-sm" color="grayDark-300" weight="medium">
                            Support Package
                          </Typography>
                          <Typography variant="text-xs" color="grayDark-400">
                            (incl. Updates)
                          </Typography>
                        </div>
                      </td>
                      {packages.map((pkg, index) => {
                        const previousPackage = index > 0 ? packages[index - 1] : null;
                        const hasUpdateDuration = pkg.freeUpdateDuration !== undefined;
                        const hasServices = pkg.services && pkg.services.length > 0;
                        const hasContent = hasUpdateDuration || hasServices;

                        return (
                          <td
                            key={pkg._id}
                            data-column={`${index + 1}`}
                            onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                            style={{ verticalAlign: 'top' }}
                          >
                            {hasContent ? (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 8,
                                  alignItems: 'center',
                                  textAlign: 'center',
                                }}
                              >
                                {previousPackage && (
                                  <Typography
                                    variant="text-sm"
                                    color="grayDark-50"
                                    weight="semibold"
                                    style={{
                                      fontSize: '14px',
                                      lineHeight: '1.4',
                                    }}
                                  >
                                    All in {previousPackage.name}
                                  </Typography>
                                )}
                                {hasUpdateDuration && (
                                  <Typography variant="text-sm" color="grayDark-400">
                                    <span
                                      style={{
                                        color: 'var(--color-gray-dark-50)',
                                        fontWeight: 600,
                                      }}
                                    >
                                      {pkg.freeUpdateDuration}
                                    </span>
                                    {` mo. inclusive support`}
                                  </Typography>
                                )}
                                {hasServices && (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: 4,
                                    }}
                                  >
                                    {pkg.services!.map((service, idx) => (
                                      <Typography key={idx} variant="text-sm" color="grayDark-400">
                                        {service}
                                      </Typography>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <Typography variant="text-sm" color="grayDark-400">
                                —
                              </Typography>
                            )}
                          </td>
                        );
                      })}
                      {data.showSourceCode && (
                        <td
                          data-column={`${packages.length + 1}`}
                          onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                          style={{ verticalAlign: 'top' }}
                        >
                          <Typography variant="text-sm" color="grayDark-400">
                            —
                          </Typography>
                        </td>
                      )}
                    </tr>
                  )}
                  <tr className={styles.actionRow}>
                    <td data-column="0"></td>
                    {packages.map((pkg, index) => (
                      <td
                        key={pkg._id}
                        data-column={`${index + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${index + 1}`)}
                      >
                        <Button
                          variant="primary"
                          onClick={() => {
                            setSelectedPackage(pkg);
                            setBinaryOpen(true);
                          }}
                          fullWidth
                        >
                          {promotion && promotion.isActive ? promotion.name : 'Select'}
                        </Button>
                      </td>
                    ))}
                    {data.showSourceCode && (
                      <td
                        data-column={`${packages.length + 1}`}
                        onMouseEnter={() => setHoveredColumn(`${packages.length + 1}`)}
                      >
                        <Button variant="primary" href="/contact-us" fullWidth>
                          Contact us
                        </Button>
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Mobile/Tablet Card View */}
            <div className={styles.packagesCardWrapper}>
              {packages.map((pkg, index) => {
                const previousPackage = index > 0 ? packages[index - 1] : null;
                const hasUpdateDuration = pkg.freeUpdateDuration !== undefined;
                const hasServices = pkg.services && pkg.services.length > 0;
                const hasSupportContent = hasUpdateDuration || hasServices;

                return (
                  <div key={pkg._id} className={styles.packageCard}>
                    <div className={styles.packageCardHeader}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <Typography variant="text-md" color="grayDark-50" weight="semibold">
                          {pkg.name}
                        </Typography>
                        {pkg.subtitle && (
                          <Typography variant="text-sm" color="grayDark-400">
                            {pkg.subtitle}
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div className={styles.packageCardContent}>
                      <div className={styles.packageCardRow}>
                        <Typography variant="text-sm" color="grayDark-300" weight="medium">
                          Supported hosts
                        </Typography>
                        <Typography variant="text-sm" color="grayDark-400">
                          {pkg.hostLimit.toLocaleString()}
                        </Typography>
                      </div>
                      <div className={styles.packageCardRow}>
                        <Typography variant="text-sm" color="grayDark-300" weight="medium">
                          Development machines
                        </Typography>
                        <Typography variant="text-sm" color="grayDark-400">
                          {index === packages.length - 1
                            ? `${pkg.hardwareLimit.toLocaleString()}+`
                            : pkg.hardwareLimit.toLocaleString()}
                        </Typography>
                      </div>
                      <div className={`${styles.packageCardRow} ${styles.highlightedCardRow}`}>
                        <Typography variant="text-sm" color="grayDark-300" weight="medium">
                          Normal price
                        </Typography>
                        <Typography
                          variant="text-sm"
                          color={promotion && promotion.isActive ? 'grayDark-400' : 'grayDark-50'}
                          weight={promotion && promotion.isActive ? undefined : 'semibold'}
                          style={
                            promotion && promotion.isActive
                              ? {
                                  textDecoration: 'line-through',
                                  opacity: 0.6,
                                }
                              : {}
                          }
                        >
                          {currency === 'eur'
                            ? `€${pkg.price.eur.toLocaleString()}`
                            : `€${pkg.price.eur.toLocaleString()}`}
                        </Typography>
                      </div>
                      {/* Pre order row - only show if promotion exists */}
                      {promotion && promotion.isActive && (
                        <div className={styles.packageCardRow}>
                          <div className={styles.preorderLabelContainer}>
                            <Typography variant="text-sm" color="grayDark-300" weight="medium">
                              {promotion.name}
                            </Typography>
                            {activeStep && (
                              <Typography
                                variant="text-xs"
                                className={styles.preorderDescriptionLabel}
                              >
                                {activeStep.discountPercentage}% {promotion.description}
                              </Typography>
                            )}
                          </div>
                          {(() => {
                            // Calculate final price with discount from active step for mobile view
                            // We need to get the package price, but in mobile view we're inside packages.map
                            // So we'll calculate it per package
                            const packagePrice = currency === 'eur' ? pkg.price.eur : pkg.price.usd;
                            const finalPrice = activeStep
                              ? packagePrice * (1 - activeStep.discountPercentage / 100)
                              : packagePrice;

                            return (
                              <Typography variant="text-sm" className={styles.preorderPrice}>
                                {currency === 'eur'
                                  ? `€${Math.round(finalPrice).toLocaleString()}`
                                  : `€${Math.round(finalPrice).toLocaleString()}`}
                              </Typography>
                            );
                          })()}
                        </div>
                      )}
                      {hasSupportContent && (
                        <div
                          className={`${styles.packageCardRow} ${styles.highlightedCardRow}`}
                          style={{ alignItems: 'flex-start' }}
                        >
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <Typography variant="text-sm" color="grayDark-300" weight="medium">
                              Support Package
                            </Typography>
                            <Typography variant="text-xs" color="grayDark-400">
                              (incl. Updates)
                            </Typography>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 8,
                              alignItems: 'flex-end',
                              textAlign: 'right',
                            }}
                          >
                            {previousPackage && (
                              <Typography
                                variant="text-sm"
                                color="grayDark-50"
                                weight="semibold"
                                style={{
                                  fontSize: '14px',
                                  lineHeight: '1.4',
                                }}
                              >
                                All in {previousPackage.name}
                              </Typography>
                            )}
                            {hasUpdateDuration && (
                              <Typography variant="text-sm" color="grayDark-400">
                                <span
                                  style={{ color: 'var(--color-gray-dark-50)', fontWeight: 600 }}
                                >
                                  {pkg.freeUpdateDuration}
                                </span>
                                {` mo. inclusive support`}
                              </Typography>
                            )}
                            {hasServices && (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 4,
                                  alignItems: 'flex-end',
                                }}
                              >
                                {pkg.services!.map((service, idx) => (
                                  <Typography key={idx} variant="text-sm" color="grayDark-400">
                                    {service}
                                  </Typography>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.packageCardFooter}>
                      <Button
                        variant="primary"
                        onClick={() => {
                          setSelectedPackage(pkg);
                          setBinaryOpen(true);
                        }}
                        fullWidth
                      >
                        {promotion && promotion.isActive ? promotion.name : 'Select'}
                      </Button>
                    </div>
                  </div>
                );
              })}
              {data.showSourceCode && (
                <div className={styles.packageCard}>
                  <div className={styles.packageCardHeader}>
                    <Typography variant="text-md" color="grayDark-50" weight="semibold">
                      Source Code
                    </Typography>
                  </div>
                  <div className={styles.packageCardContent}>
                    <div className={styles.packageCardRow}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Supported hosts
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                    <div className={styles.packageCardRow}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Development machines
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                    <div className={`${styles.packageCardRow} ${styles.highlightedCardRow}`}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Normal price
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                    <div className={styles.packageCardRow}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Pre order
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                    <div className={`${styles.packageCardRow} ${styles.highlightedCardRow}`}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Free updates & new features
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                    <div className={styles.packageCardRow}>
                      <Typography variant="text-sm" color="grayDark-300" weight="medium">
                        Support package
                      </Typography>
                      <Typography variant="text-sm" color="grayDark-400">
                        —
                      </Typography>
                    </div>
                  </div>
                  <div className={styles.packageCardFooter}>
                    <Button variant="primary" href="/contact-us" fullWidth>
                      Contact us
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {data.showBinary && packagesLoading && packages.length === 0 && (
          <div className={styles.packagesTableWrapper}>
            <div className={styles.tableSkeleton}>
              <div className={styles.skeletonRow}></div>
              <div className={styles.skeletonRow}></div>
              <div className={styles.skeletonRow}></div>
            </div>
          </div>
        )}
      </div>
      {/* Binary Modal */}
      <BinaryModal
        isOpen={binaryOpen}
        onClose={() => {
          setBinaryOpen(false);
          setSelectedPackage(null);
        }}
        topOffset={isMobile ? 56 : 72}
        productId={productId}
        selectedPackage={selectedPackage}
      />
    </div>
  );
};

export default LicensingOptions;
